import { useState } from "react";
import { put } from "../../../common/api/apiShared";
import { Result } from "../../../common/api/result";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation";
import { useValidator } from "../../../common/hooks/validation";
import { RiskVersionSaveModel } from "../riskAssessmentVersions/RiskAssessmentVersions.types";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { IEditRiskAssessmentVersionDialog } from "./EditRiskAssessmentVersionDialog";

export function useEditRiskVersionDialogHooks(props: IEditRiskAssessmentVersionDialog) {
    const snackbar = useDotLegalSnackbar();
    const { translateString } = useTranslation();
    const [version, setVersion] = useState<RiskVersionSaveModel>(props.selectedVersion);

    const validation = useValidator<RiskVersionSaveModel>((validators) => ({
        name: validators.validateNotEmpty((item) => item.name, translateString("name")),
    }));

    const editMutation = useDotLegalMutation(edit);

    function edit(doc: RiskVersionSaveModel) {
        return put<string>(`/riskassesmentversions/${version.id!}`, doc);
    }

    const update = () => {
        editMutation.mutateAsync(version!, {
            onSuccess: (response: Result<string>) => {
                if (response.success()) {
                    props.onVersionSaved();
                    snackbar.show(translateString("riskVersionUpdated"));
                } else {
                    snackbar.show(translateString("riskVersionExists"), "warning");
                }
            },
        });
    };

    const onSaveClick = () => {
        if (validation.anyHasErrors) {
            validation.setShowErrors(true);
            return;
        }

        update();
    };

    const modelUpdater = {
        onNameChange: (name: string) => {
            let temp = { ...version };
            temp.name = name;
            setVersion(temp);
        },
        onDescriptionChange: (description: string) => {
            let temp = { ...version };
            temp.description = description;
            setVersion(temp);
        },
        onIsCurrentChange: (isCurrent: boolean) => {
            let temp = { ...version };
            temp.isCurrent = isCurrent;
            setVersion(temp);
        },
    };

    return {
        onSaveClick,
        inProgress: editMutation.isLoading,
        version,
        validation,
        modelUpdater,
    };
}
